import $ from "jquery";


export default class myPlugin extends $ {


    constructor(){
        super();
    }
}


// WEBPACK FOOTER //
// ./src/lib/type.js